import React from 'react';
import { useTranslation } from '../../utils/useTranslation';
import { CategoryPicker } from '../categories/CategoryPicker';
import { Button } from '../input/Button';
import { Box } from '../layout/Box';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';
import type { CategoryUI } from '../categories/types';

interface UserSettingsProps {
    categories: CategoryUI[];
    selectedCategories: Array<CategoryUI['id']>;
    onCategoriesChange: (value: Array<CategoryUI['id']>) => void;
    onSave: () => void;
}

export function UserSettings(props: UserSettingsProps) {
    const { categories, selectedCategories, onCategoriesChange, onSave } = props;
    const t = useTranslation();

    return (
        <Flex width="100%" height="100%" backgroundColor="var(--background-primary)">
            <Flex
                px={3}
                pt={2.5}
                spacing={2}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
            >
                <Typography color="link" variant="body" weight="bold">
                    {t('Я — автор')}
                </Typography>
            </Flex>
            <Flex justifyContent="flex-start" width="100%" height="100%" pb={8}>
                <Box pt={4} px={3}>
                    <Typography variant="title1" weight="bold">
                        {t('Расскажите о своих интересах')}
                    </Typography>
                </Box>
                <Box pt={2.5} px={3}>
                    <Typography variant="body" weight="bold" color="secondary">
                        {t('Подберём для вас кое-что увлекательное')}
                    </Typography>
                    <Typography variant="body" weight="bold" color="secondary">
                        {t('Выберите как минимум 3 категории')}
                    </Typography>
                </Box>
                <CategoryPicker
                    items={categories}
                    value={selectedCategories}
                    onChange={onCategoriesChange}
                />
                {selectedCategories.length >= 3 && (
                    <Flex width="100%" height="100%" alignItems="center" justifyContent="flex-end">
                        <Button size="l" onClick={onSave}>
                            {t('Далее')}
                        </Button>
                    </Flex>
                )}
            </Flex>
        </Flex>
    );
}
